import { render, staticRenderFns } from "./HandoverBlock.vue?vue&type=template&id=2f58a44e&scoped=true&"
import script from "./HandoverBlock.vue?vue&type=script&lang=js&"
export * from "./HandoverBlock.vue?vue&type=script&lang=js&"
import style0 from "./HandoverBlock.vue?vue&type=style&index=0&id=2f58a44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58a44e",
  null
  
)

export default component.exports